import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CLEAR_ERROR,
  FETCH_PROFILE,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  authLoading: true,
  isAuthenticated: false,
  user: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: "",
      }

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        authLoading: false,
        isAuthenticated: true,
        user: action.payload,
      }

    case LOGOUT_USER:
      return { ...state }

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      }

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case CLEAR_ERROR:
      return {
        ...state,
        error: "",
      }

    case FETCH_PROFILE:
      return {
        ...state,
        authLoading: !state.isAuthenticated,
      }

    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        authLoading: false,
        isAuthenticated: true,
        user: action.payload,
      }

    case FETCH_PROFILE_FAILURE:
      return {
        ...state,
        authLoading: false,
        ...(state.isAuthenticated && state.user
          ? {}
          : { isAuthenticated: false, user: null }),
      }

    default:
      return state
  }
}

export default login
